type TableDataType = {
  colHead: number
  col1: number
  col2: number
  col3: number
  col4: number
}

export const integrationData: TableDataType[] = [
  {
    colHead: 1,
    col1: 1,
    col2: 2,
    col3: 5,
    col4: 10,
  },
  {
    colHead: 5,
    col1: 1,
    col2: 2,
    col3: 5,
    col4: 10,
  },
  {
    colHead: 20,
    col1: 1,
    col2: 2,
    col3: 5,
    col4: 10,
  },
  {
    colHead: 100,
    col1: 1,
    col2: 2,
    col3: 5,
    col4: 10,
  },
  {
    colHead: 500,
    col1: 1,
    col2: 2,
    col3: 5,
    col4: 10,
  },
]

export const ipaasData: TableDataType[] = [
  {
    colHead: 1,
    col1: 1,
    col2: 2,
    col3: 5,
    col4: 10,
  },
  {
    colHead: 5,
    col1: 5,
    col2: 10,
    col3: 25,
    col4: 50,
  },
  {
    colHead: 20,
    col1: 20,
    col2: 40,
    col3: 100,
    col4: 200,
  },
  {
    colHead: 100,
    col1: 100,
    col2: 200,
    col3: 500,
    col4: 1000,
  },
  {
    colHead: 500,
    col1: 500,
    col2: 1000,
    col3: 2500,
    col4: 5000,
  },
]
